export default __webpack_public_path__ + "static/media/3rd.67a7924b.png";